import React from "react";

const AboutUs = () => {
  return (
    <section className="about-us">
      <div className="container text-center">
        <div className="row">
          <div className="col-xl-6 col-lg-8 col-10 m-auto">
            <h2>ABOUT US</h2>
            <h3>Ultimate capability. Calm in adversity.</h3>
            <p>
              Parabellum offers tailored training programmes and unique,
              intelligent experiences to equip elite individuals with the
              skills, intuition and preparation they require to function
              professionally at the highest level.
            </p>
            <p>
              Founded by members of Israeli intelligence communities and elite
              special forces, Parabellum’s philosophy and services are based on
              advanced knowledge of espionage, survival, anti-terrorism, hostage
              negotiation, combat and psychological warfare methods.
            </p>
            <p>
              The Parabellum experience is designed to challenge physically,
              emotionally and intellectually. Tailor-made to each client’s
              capabilities and resulting in better focus, preparation and
              ability to deal with extreme stress and unconventional,
              highly-charged situations
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
